export default __webpack_public_path__ + "static/vi-testimonial-bg-mobile-light-2542b7a33257ca3933f1be589854592c.png";